
















































import { Component, Vue } from "vue-property-decorator";
import { ROUTE_NAMES, VAL_TYPES } from "../configs";

@Component
export default class JoinDialog extends Vue {
  dialog = false;
  roomCode = "";
  error = "";

  onConfirm() {
    if (this.roomCode.length <= 7 && this.roomCode.length >= 6)
      this.$router.push({
        name: ROUTE_NAMES.validate,
        params: {
          valType: VAL_TYPES.join,
          roomId: this.roomCode
        }
      });
    else this.error = "Enter a valid room code";
  }
}
